var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ContextMenuAFY, icons, sizes, sizesIcon, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
export var viewType = {
    insurersView: [
        {
            active: true,
            icon: {
                icon: icons.GridView,
            },
            id: "1",
            name: "CardView",
        },
        {
            active: false,
            icon: {
                icon: icons.List,
            },
            id: "2",
            name: "List",
        },
        {
            active: false,
            icon: {
                icon: icons.BlurLinear,
            },
            id: "3",
            name: "GridView",
        },
    ],
    title: "Roles",
    titleColor: "#3A56A1",
};
export var AdminRolesDTO = {
    viewTypeProps: viewType,
    paginationProps: {
        count: 100,
        labelRowsPerPage: "Filas por página",
        pagePagination: 0,
        rowsPerPageOptions: [19, 35, 50],
        rowsPerPages: 0,
        showFirstButton: true,
        showLastButton: true,
    },
    drawerProps: {
        BgBackdrop: "rgb(0 0 0 / 69%)",
        BgcCloseButton: "#FFFFFF",
        bgColorDrawer: " #FFFFFF",
        colorIcon: "#3A56A1",
        openDrawer: false,
        showButton: true,
        title: "Permisos",
        titleButton: "",
        view: 1,
    },
    cardsDataProps: {
        id: "",
        backgroundColor: "#FFFFFF",
        height: "136px",
        heightList: "68px",
        isList: false,
        menuItem: [
            {
                disabled: false,
                icon: {
                    color: "#006ac6",
                    icon: icons.Edit,
                    size: sizesIcon.standard,
                },
                id: "1",
                name: "Modificar",
            },
            {
                disabled: false,
                icon: {
                    color: "#006ac6",
                    icon: icons.Visibility,
                    size: sizesIcon.standard,
                },
                id: "2",
                name: "Ver Permisos",
            },
            // {
            //   disabled: false,
            //   icon: {
            //     color: "#006ac6",
            //     icon: icons.DeleteForever,
            //     size: sizesIcon.standard,
            //   },
            //   id: "3",
            //   name: "Eliminar",
            // },
        ],
    },
    cardAddNewProps: {
        backgroundColor: "#FFFFFF",
        height: 136,
        heightList: 68,
        icon: icons.AddCircle,
        iconColor: "#3A56A1",
        title: "Crear Rol",
    },
    buttonAddProps: {
        label: "Crear Rol",
        size: sizes.large,
        variant: variants.contained,
    },
    tableProps: {
        columnHeaderHeight: 32,
        height: "300px",
        rowHeight: 35,
        width: "100%",
        columns: [
            {
                field: "name",
                headerName: "Nombre Rol",
                width: 300,
            },
            {
                field: "description",
                headerName: "Descripción",
                width: 300,
            },
            {
                field: "type",
                headerName: "Tipo",
                width: 250,
            },
            {
                field: "enabled",
                flex: 1,
                headerName: "Estado",
            },
            {
                field: "refName",
                flex: 1,
                headerName: "Nombre de referencia",
            },
            {
                field: "createdAt",
                flex: 1,
                headerName: "Fecha de creación",
            },
            {
                field: "disabledReason",
                flex: 1,
                headerName: "Motivo de inactivación",
            },
            {
                field: "deletedReason",
                flex: 1,
                headerName: "Motivo de eliminación",
            },
        ],
        rows: [],
        multipleSelection: false,
        pageSize: 20,
    },
    filterReportProps: {
        filters: [
            {
                active: true,
                backgroundColor: "#E8EEFF",
                border: true,
                borderRadius: "8px",
                borderType: "1px solid #96ABFF",
                color: "#0D1BD9",
                id: "fullTextSearch",
                sizes: "40px",
                type: "fullTextSearch",
            },
        ],
    },
    viewGridProps: function (onOptionsCardClick) { return ({
        width: "100%",
        height: "100%",
        columnHeaderHeight: 32,
        rowHeight: 35,
        hideFooterPagination: true,
        pageSize: 19,
        hidePagination: true,
        columns: [
            {
                field: "type",
                headerName: "Acciones",
                width: 75,
                renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "transparent", iconButton: icons.MoreVert, disableRipple: true, iconColor: "#3A56A1", menuItem: [
                            {
                                disabled: false,
                                icon: {
                                    color: "#006ac6",
                                    icon: icons.Edit,
                                    size: sizesIcon.standard,
                                },
                                id: "1",
                                name: "Modificar",
                            },
                            {
                                disabled: false,
                                icon: {
                                    color: "#006ac6",
                                    icon: icons.Visibility,
                                    size: sizesIcon.standard,
                                },
                                id: "2",
                                name: "Ver Roles",
                            },
                        ], onClickContextMenu: function (opt) {
                            return onOptionsCardClick === null || onOptionsCardClick === void 0 ? void 0 : onOptionsCardClick(opt, params.row);
                        }, sizeIcon: sizesIcon.smallXl }) }))); },
            },
            {
                field: "code",
                headerName: "Nombres",
                width: 250,
            },
            {
                field: "description",
                headerName: "Descripción",
                flex: 1,
            },
        ],
        rows: [],
    }); },
};
export var DataFormUsers = {
    idType: "",
    documentNumber: "",
    names: "",
    lastNames: "",
    birthday: "",
    gender: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    company: "",
    branch: "",
};
export var ModalUiProps = {
    title: "",
    name: "",
    openModal: false,
    onClose: function () { },
    minWidthModal: "1000px",
    minHeightModal: "440px",
    backgroundColor: "#E8E8E8",
    closeModalOutside: true,
    showButtons: true,
    buttonAdd: {
        label: "Asignar",
        variant: variants.contained,
    },
    buttonCancel: {
        label: "Cancelar",
        variant: variants.outlined,
    },
};
export var AddPermissionToRol = {
    mode: "permissions",
    showType: true,
    assignedTitle: "Permisos Asignados",
    availableTitle: "Permisos Disponibles",
    searchPlaceholder: "Buscar Permiso",
    assignedItems: [],
    availableItems: [],
};
export var datoForm = {
    name: "",
    description: "",
    permissions: [],
};
